var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReinvest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 7.296 15.113 L 5.154 12.971 L 3.011 15.113 M 25.868 16.541 L 28.011 18.685 L 30.155 16.541",
    fill: "transparent",
    strokeWidth: 2,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 28.011 18.685 L 28.011 15.828 C 28.011 9.516 22.894 4.399 16.582 4.399 C 13.114 4.397 9.833 5.974 7.668 8.684 M 5.154 12.971 L 5.154 15.828 C 5.154 22.14 10.27 27.256 16.582 27.256 C 20.19 27.256 23.401 25.58 25.496 22.97 M 17.303 16.375 L 19.482 19.636",
    fill: "transparent",
    strokeWidth: 2,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 14.043 16.375 L 17.303 16.375 C 18.506 16.375 19.482 15.399 19.482 14.196 C 19.482 12.992 18.506 12.017 17.303 12.017 L 14.042 12.017 L 14.042 19.637",
    fill: "transparent",
    strokeWidth: 2.29,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReinvest);
export default __webpack_public_path__ + "static/media/reinvest.833ad250bb9960994bb4b3ef89d0bf5d.svg";
export { ForwardRef as ReactComponent };